export default __webpack_public_path__ + "static/media/survey-insights.fc124f55.svg";